import { ApiService } from "../api-service/api.service";
import { AuthService } from "../auth/auth.service";
import { Injectable } from "@angular/core";
import { Logging } from "../../logging";


export  class ComponentID
{
    DEFAULT : string = "RED00";
    USERS : string= "RED02";
    DOCUMENTS : string = "RED07";
    BANK_ACCOUNTS : string = "RED09";
    MM_WALLETS : string = "RED10";
    APPS : string ="RED11";
    REPORTS : string ="RED12";
    CASH_OUT : string ="RED08";
}

export class ActionType
{
    ADD : string = "canadd";
    EDIT : string = "canedit";
    VIEW : string = "canview";
    DELETE : string = "candelete";
    APPROVE : string = "canapprove";

    getProperty(name :string) {
        switch(name)
        {
            case 'ADD':
                return this.ADD;
            case 'EDIT':
                return this.EDIT;
            case 'VIEW':
                return this.VIEW;
            case 'DELETE':
                return this.DELETE;
            case 'APPROVE':
                return this.APPROVE;
            
        }
    }

}


@Injectable()
export class PermissionHelper
{
   // user : any = null;
   // isloggedin :Boolean = false;


    constructor(private api: ApiService, private auth: AuthService) {
       // this.user = this.auth.user();
      //  this.isloggedin = (this.user !== null) ? true: false;
    }

    getProfileName()
    {
        if(this.auth.user() === null) 
        {
            return null;
        }

        return this.auth.user().profile.profilename;
    }

    isloggedin()
    {
        return (this.auth.user() !== null) ? true: false;
    }


    hasPermission( pageid:string, action :string) : Boolean
    {
        if(!this.isloggedin())
        {
            return false;
        }

        //Logging.log( this.user.profile.permissions);

        const foundperm = this.auth.user().profile.permissions.filter(perm => perm.authitemid == pageid);
        if(!foundperm || foundperm.length == 0)
        {
            return false;
        }
        
        //Logging.log(foundperm);
       return foundperm[0][action] ;

    }

    hasPermissionForOthers( pageid:string, action :string, userid:String) : Boolean
    {
        //Logging.log(pageid +":"+ action + ":" +userid);
        const perm = this.hasPermission(pageid,action);
        return (perm && this.auth.user().userid != userid);

    }

    getComponentPermissions(pageid:string)
    {
        if(!this.isloggedin())
        {
            return null;
        }

        return this.auth.user().profile.permissions.filter(perm => perm.authitemid == pageid);
    }





}


// WEBPACK FOOTER //
// ./src/app/shared/helpers/permissionshelper.ts